import React, { createContext, useContext, useState } from "react";

// Create a context for authentication
const MainContext = createContext();

export const MainProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [authStatus, setAuthStatus] = useState(false);

  // Define functions to modify state, e.g., login, logout
  const loginUser = userData => {
    setUserInfo(userData);
    setAuthStatus(true);
  };

  const logoutUser = () => {
    setUserInfo(null);
    setAuthStatus(false);
  };

  // The value provided to the context consumers
  const contextValues = {
    loginUser, // Add info user and login status to Context
    logoutUser, // Remove info user and login status to Context
    userInfo,
    setUserInfo,
    authStatus,
    setAuthStatus,
  };

  return (
    <MainContext.Provider value={contextValues}>
      {children}
    </MainContext.Provider>
  );
};

// Custom hook to use Auth Context
export const useAuth = () => useContext(MainContext);
